import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Globe2, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-md bg-slate-900 flex items-center justify-center">
              <Globe2 className="w-4 h-4 text-white" />
            </div>
            <span className="font-display font-bold text-slate-900">{t("brand.full")}</span>
          </div>
          <p className="text-sm text-slate-600 max-w-md leading-relaxed mb-4">{t("footer.tagline")}</p>
          <a href="mailto:contact@k2mondemploiconnect.com" className="inline-flex items-center gap-1.5 text-xs text-slate-600 hover:text-[#004EEB] transition" data-testid="footer-email">
            <Mail className="w-3.5 h-3.5" /> contact@k2mondemploiconnect.com
          </a>
        </div>
        <div>
          <h4 className="font-semibold text-slate-900 mb-3 text-sm">{t("footer.platform")}</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/jobs" className="hover:text-slate-900">{t("header.jobs")}</Link></li>
            <li><Link to="/pricing" className="hover:text-slate-900">{t("header.pricing")}</Link></li>
            <li><Link to="/register" className="hover:text-slate-900">{t("auth.create_account")}</Link></li>
            <li><Link to="/support" className="hover:text-slate-900" data-testid="footer-support">{t("footer.support")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-slate-900 mb-3 text-sm">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/legal" className="hover:text-slate-900" data-testid="footer-legal">{t("footer.legal_notice")}</Link></li>
            <li><Link to="/privacy" className="hover:text-slate-900" data-testid="footer-privacy">{t("footer.privacy")}</Link></li>
            <li><Link to="/terms" className="hover:text-slate-900" data-testid="footer-terms">{t("footer.terms")}</Link></li>
            <li><Link to="/cgv" className="hover:text-slate-900" data-testid="footer-cgv">{t("footer.cgv")}</Link></li>
            <li><Link to="/cookies" className="hover:text-slate-900" data-testid="footer-cookies">{t("footer.cookies")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center gap-2">
          <span className="text-xs text-slate-500 font-mono">{t("footer.rights")}</span>
          <span className="text-xs text-slate-500">{t("footer.subline")}</span>
        </div>
      </div>
    </footer>
  );
}
